import type { SimpleResult } from "../dto";
import { Api, getCompanyId, getProcessesGetPath } from "../helpers";
import type {
  IFetchProcessesDto,
  IProcessesListResponse,
  IProcessesSearchRequest,
  IRydeProcess,
} from "../models";

export class ProcessesApi {
  // companyId override is used by global (cross-company) pages such as backup management,
  // where the process can belong to a company other than the currently-selected one.
  static async getOne(
    id: number,
    companyId?: number,
  ): Promise<IRydeProcess | undefined> {
    const requestUrl = `${getProcessesGetPath(companyId ?? getCompanyId() ?? 0)}/${id}`;
    const response = await Api.get<IRydeProcess>(requestUrl);

    return response?.data;
  }

  static async cancel(
    id: number,
    companyId?: number,
  ): Promise<SimpleResult<void> | undefined> {
    const requestUrl = `${getProcessesGetPath(companyId ?? getCompanyId() ?? 0)}/${id}/cancel`;
    const response = await Api.post<SimpleResult<void>>(requestUrl, {});

    return response?.data;
  }

  static async fetchProcesses(
    dto: IFetchProcessesDto,
  ): Promise<IRydeProcess[]> {
    const requestUrl = `${getProcessesGetPath(getCompanyId() ?? 0)}/fetchProcesses`;
    const response = await Api.post<IRydeProcess[]>(requestUrl, dto);

    return response?.data ?? [];
  }

  static async search(
    dto: IProcessesSearchRequest,
  ): Promise<IProcessesListResponse | undefined> {
    const requestUrl = `${getProcessesGetPath(getCompanyId() ?? 0)}/search`;
    const response = await Api.post<IProcessesListResponse>(requestUrl, dto);

    return response?.data;
  }

  static async download(id: number): Promise<IRydeProcess | undefined> {
    const requestUrl = `${getProcessesGetPath(getCompanyId() ?? 0)}/${id}/download`;
    const response = await Api.get<IRydeProcess>(requestUrl);

    return response?.data;
  }
}
